module.exports = __webpack_public_path__ + "iubenda-pref.svg?5c00a6e3dbb8af8320a1b4d08f629620";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iubenda-pref.svg
// module id = 34
// module chunks = 0